<div class="module module-services">
      <div class="module-title">
          <h3>Minha Conta</h3>
      </div>
      <div class="module-content">
          <div class="nav-menu">
              <ul>
                  <li>
                      <a routerLink="/minha-conta" title="Minha Conta" (click)="toRoute('/minha-conta')">
                          <span>Meu Perfil</span>
                      </a>  
                  </li> 
                  <li> 
                    <a routerLink="/minha-conta/pedidos" title="Meus Pedidos" (click)="toRoute('/minha-conta/pedidos')">
                        <span>Meus Pedidos</span>
                    </a> 
                  </li> 
                  <li>  
                    <a routerLink="/carrinho" title="Meus Pedidos" (click)="toRoute('/carrinho')">
                        <span>Carrinho de Compras</span>
                    </a> 
                  </li> 
              </ul>
          </div>
      </div>    
  </div>